import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/cart-manage-shipdates-new.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import ServiceBus from "servicestack/service-bus";
import $session from "servicestack/session";
import Product from "emun.shopping/product.model";
import modals from "webmodals/modals";
import scss from "emun.cart/cart-manage-shipdates.scss";
import cartConfig from "emun.cart/cart.config";
import orderConfig from "emun.order/order.config";
import shoppingConfig from "emun.shopping/shopping.config";

class CartManageShipdatesController extends Shared {
  constructor($cart, $state, modals, utils) {
    super($cart);
    let $stateParams = resolve("$stateParams");
    //if ($stateParams.cartId) $cart.load($stateParams.cartId);
    let $ctrl = this;
    $ctrl.allTabOpen = false;
    //$ctrl.loadShipDates
    $ctrl.currentTab = 0;
    $ctrl.cartConfig = cartConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.shoppingConfig = shoppingConfig;
    $ctrl.config = Object.assign({}, cartConfig, orderConfig);
    $ctrl.allShipDate = moment.utc($ctrl.$cart.shipOn);
    console.debug("$cart", $cart);
    $ctrl.termsQuery = new AutoQuery({
      url: `QueryPaymentTerms.json?cartId=` + $cart.id,
      take: 1000,
      autoLoad: true,
      orderBy: "Name",
    });
    $ctrl.shippingMethods = new AutoQuery({
      url:
        $cart.purchaser &&
        "QueryShippingMethods.json?retailerId=" +
          ($cart.purchaser.id != "0" ? $cart.purchaser.id : $cart.retailerId),
      criteria: {
        vendorId: $cart.vendorId,
      },
      orderBy: "Name",
      autoLoad: !!$cart.purchaser,
      pageSize: 150,
    });
    $ctrl.loadShipDates();
    let $rootScope = resolve("$rootScope");
    if (
      ($ctrl.$cart.exported ||
        $ctrl.$cart.status == "Open" ||
        $ctrl.$cart.status == "Completed") &&
      !$ctrl.$session.isAgency()
    ) {
      const minDate = moment.utc($ctrl.$cart.shipOn); //.startOf("day");
      $ctrl.minDate = minDate;
    } else if (cartConfig.shipDateDays) {
      $ctrl.minDate = moment
        .utc()
        .add(cartConfig.shipDateDays, "day")
        .startOf("day");
    } else {
      $ctrl.minDate = moment.utc().startOf("day");
    }
    $rootScope.$on("orderPOUpdated", (e, { po }) => {
      //console.debug("BL*** orderPOUpdated", po);
      $ctrl.updatePO(null, po);

    })
  }
  loadShipDates() {
    let $ctrl = this;
    if ($ctrl.uniqueShipDates) {
      $ctrl.uniqueShipDates.forEach(function (key, i) {
        if ($ctrl.shipDates[key].tabOpen) $ctrl.currentTab = i;
      });
    }
    $ctrl.uniqueShipDates = Object.keys($ctrl.$cart.shipOnIndex);
    if ($ctrl.uniqueShipDates.length === 1 || cartConfig.allTabOpen) {
      $ctrl.allTabOpen = true;
    }
    $ctrl.uniqueShipDates.sort();
    $ctrl.shipDates = $ctrl.$cart.shipOnIndex;
    $ctrl.shipDatesGroupBy = _.groupBy($ctrl.$cart.items, "shipOn"); //groupBy
    $ctrl.$shipDatesGroupBy = _.groupBy($ctrl.$cart.items, "$shipOn"); //groupBy
    var runningTotal = 0;
    $ctrl.uniqueShipDates.forEach(function (key, i) {
      $ctrl.shipDates[key].originalShipOn = moment.utc(key);
      $ctrl.shipDates[key].tabOpen = i === $ctrl.currentTab;
      $ctrl.shipDates[key].shipOn = moment.utc(key);
      $ctrl.shipDates[key].cancelOn = moment.utc($ctrl.shipDates[key].cancelOn);
      $ctrl.shipDates[key].total = 0;
      if ($ctrl.shipDatesGroupBy[key] !== undefined) {
        $ctrl.shipDatesGroupBy[key].forEach(function (obj) {
          $ctrl.shipDates[key].total += obj.extendedTotal;
					
        });
      } else if ($ctrl.$shipDatesGroupBy[key] !== undefined) {
        $ctrl.$shipDatesGroupBy[key].forEach(function (obj) {
          $ctrl.shipDates[key].total += obj.extendedTotal;
        });
      }

      runningTotal += $ctrl.shipDates[key].total;
      $ctrl.shipDates[key].runningTotal = runningTotal;
      $ctrl.shipDates[key].percentOfTotal = 100 * (runningTotal / $ctrl.$cart.subTotal);;
    });
    //https://emun1.monday.com/boards/333027351/views/4635648/pulses/4117042794
    if (cartConfig.maxCancelDaysAfterShip) {
      $ctrl.maxCancelDate = moment
      .utc($ctrl.$cart.shipOn)
      .add(cartConfig.maxCancelDaysAfterShip, "days");
    }
  }
  updatePO(key, po) {
    let $ctrl = this;
    let request = {
      cartId: $ctrl.$cart.id,
      key: key,
      purchaseOrder: po,
    };
    return $ctrl.$cart.bus
      .send("UpdateCartItemPO.json", request)
      .then(function (response) {
        $ctrl.$cart.load().then(function () {
          $ctrl.loadShipDates();
        });
      });
  }
  updateTerms(key, terms) {
    let $ctrl = this;
    let request = {
      cartId: $ctrl.$cart.id,
      key: key,
      terms: terms,
    };
    return $ctrl.$cart.bus
      .send("UpdateCartItemTerms.json", request)
      .then(function () {
        $ctrl.$cart.load().then(function () {
          $ctrl.loadShipDates();
        });
      });
  }
  updateShipMethod(key, shipMethod) {
    let $ctrl = this;
    let request = {
      cartId: $ctrl.$cart.id,
      key: key,
      shipMethod: shipMethod,
    };
    return $ctrl.$cart.bus
      .send("UpdateCartItemShipMethod.json", request)
      .then(function (response) {
        $ctrl.$cart.load().then(function () {
          $ctrl.loadShipDates();
        });
      });
  }
  updateShipDate(key, shipDate, force) {
    let $ctrl = this;
    let request = {
      cartId: $ctrl.$cart.id,
      key: key,
      shipOn: shipDate,
    };
    if (key === null) {
      if (
        $ctrl.allTabOpen &&
        ($ctrl.allShipDate.format("MM/DD/YYYY") !==
          $ctrl.$cart.shipOn.format("MM/DD/YYYY") ||
          force)
      ) {
        return modals
          .confirm(
            "Are you sure you want to change the shipdate for all items on this order?",
            "Change Ship Date"
          )
          .result.then(function () {
            return $ctrl.$cart.bus
              .send("UpdateCartItemShipDate.json", request)
              .then(function (response) {
                if (response.data.exceptions)
                  modals.alert(
                    "There were line items on your Order that could not be changed based on the Default Availability Date"
                  );
                else {
                  $ctrl.$cart.load().then(function () {
                    $ctrl.loadShipDates();
                  });
                }
              });
          });
      }
    } else {
      return $ctrl.$cart.bus
        .send("UpdateCartItemShipDate.json", request)
        .then(function (response) {
          if (response.data.exceptions)
            modals.alert(
              "There were line items on your Order that could not be changed based on the Default Availability Date"
            );
          else {
            $ctrl.$cart.load().then(function () {
              $ctrl.loadShipDates();
            });
          }
        });
    }
  }
  updateCancelDate(key, cancelDate) {
    let $ctrl = this;
    //console.debug("Update CancelDate", key, cancelDate);
    let request = {
      cartId: $ctrl.$cart.id,
      key: key,
      cancelOn: cancelDate,
    };
    $ctrl.batch = key === null;
    //console.debug("$ctrl.batch", $ctrl.batch);
    return $ctrl.$cart.bus
      .send("UpdateCartItemCancelDate.json", request)
      .then(function (response) {
        return $ctrl.$cart.load().then(function () {
          return $ctrl.loadShipDates();
        });
      })
      .finally((s) => ($ctrl.batch = false));
  }
  applySettings() {
    let $ctrl = this;
    $ctrl.updateShipDate(null, $ctrl.$cart.shipOn).then(function () {
      $ctrl.updateCancelDate(null, $ctrl.$cart.cancelOn).then(function () {
        $ctrl.updatePO(null, $ctrl.$cart.purchaseOrder).then(function () {
          $ctrl.updateTerms(null, $ctrl.$cart.paymentTermsId).then(function () {
            $ctrl
              .updateShipMethod(null, $ctrl.$cart.shippingMethodId)
              .then(function () {
                $ctrl.$cart.load().then(function () {
                  $ctrl.loadShipDates();
                });
              });
          });
        });
      });
    });
  }
}

let CartManageShipdates = {
  controller: CartManageShipdatesController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default CartManageShipdates;
